const styles = (theme: any) => ({
  editReferenceRateModal: {
    minWidth: '45%',
  },
  formError: {
    color:'red',
    width: '100%',
    textAlign: 'center',
    minHeight: '21px',
    marginBottom: '5px',
  },
  selectContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 0.2fr 1fr 1fr 1fr',
    gridColumnGap: '2px',
  },
  selectlabel: {
    minWidth: '150px',
  },
  rateSelect: {
    minWidth: '120px',
  },
  referenceRateRadio: {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
    fontSize: '14px',
  },
  okButton: {
    backgroundColor: 'rgb(24, 144, 255)',
    border: '1px solid rgb(24, 144, 255)',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: 'rgb(24, 144, 255)',
      border: '1px solid rgb(24, 144, 255)',
      color: '#FFFFFF',
    },
    '&:focus': {
      backgroundColor: 'rgb(24, 144, 255)',
      border: '1px solid rgb(24, 144, 255)',
      color: '#FFFFFF',
    },
  },
  perTrailer: {
    fontStyle: 'italic',
    fontSize: '12px',
    color: '#262626',
    margin: '8px 0 0 6px',
  },
});

export default styles;
